import PropTypes from 'prop-types';
import Select from 'react-select';

const SelectNumberImages = ({ onSelect }) => {
  const customStyles = {
    option: (provided, state, styles) => ({ marginBottom: 10 }),

    menuList: () => ({
      position: 'absolute',
      width: 300,
      color: '#8C8C8C',
      backgroundColor: '#FFFFFF',
      marginTop: 30,
      borderRadius: '30px',
      paddingTop: 20,
      paddingLeft: 20,
      paddingBottom: 10,
      fontSize: 16,
      fontFamily: 'Jost',
      fontWeight: 400,
      lineHeight: 1.5,
      overflow: 'hidden',
      left: -120,
      zIndex: 1000,
    }),

    menu: () => ({
      height: 0,
      marginTop: 0,
    }),

    control: () => ({
      marginLeft: 10,
      width: 101,
      height: 40,
      backgroundColor: '#F8F8F7',
      borderRadius: 10,
      fontSize: 16,
      fontFamily: 'Jost',
      fontWeight: 400,
      lineHeight: 1.5,
      color: '#1D1D1D',
    }),

    clearIndicator: () => ({ display: 'none' }),

    dropdownIndicator: () => ({
      position: 'absolut',
      marginLeft: 75,
      marginTop: -55,
      color: '#8C8C8C',
    }),

    singleValue: (provided, state) => {
      const opacity = state.isDisabled ? 0.5 : 1;
      const transition = 'opacity 300ms';

      return { ...provided, opacity, transition };
    },
  };

  const options = [
    { value: 5, label: 'Limit: 5' },
    { value: 10, label: 'Limit: 10' },
    { value: 15, label: 'Limit: 15' },
    { value: 20, label: 'Limit: 20' },
  ];

  const handleSelect = ({ value }) => {
    onSelect(value);
  };

  return (
    <Select
      options={options}
      placeholder={'All breeds'}
      styles={customStyles}
      onChange={handleSelect}
      defaultValue={options[1]}
    />
  );
};

export { SelectNumberImages };

SelectNumberImages.propTypes = {
  onSelect: PropTypes.func.isRequired,
};
